
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#D6DBEA","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M30.771 11.104a1.227 1.227 0 00-1.432.332 1.209 1.209 0 00-.074 1.461A16.175 16.175 0 0130 29.419a10.517 10.517 0 01-3.706-4.636 1.224 1.224 0 00-1.696-.71c-5.298 2.31-8.685 7.552-8.595 13.3C16.154 46.048 23.272 53 32 53 40.729 53 47.847 46.048 48 37.373c-.137-11.334-6.85-21.57-17.229-26.27z"}})])
          )
        }
      }
    